<app-project-item-list
  itemRouteSuffix="/project-summary-report"
  title="Select Project"
></app-project-item-list>
